<ng-template #createTicketModalForm role="document" let-modal>

  @if(!embeddedFormMode) {
    <app-modal-comp-header
      [title]="formTitle"
      (cancelButtonOnClick)="closeForm(); modal.dismiss('Cross click')"
    ></app-modal-comp-header>
  }

  <div class="row">
    <div [className]="embeddedFormMode ? 'col-3' : 'col-0'"></div>
    <div [className]="embeddedFormMode ? 'col-6' : 'col-0'">

    <form (ngSubmit)="saveFormData()" [formGroup]="ticketForm" class="tablelist-form" autocomplete="off">
      <div class="modal-body">

        <div class="row">
          <div class="col-6">
            <div class="mb-3">
              <label for="companyId-field" class="form-label text-right required">Company</label>
              <div class="input-group">
                <select
                  class="form-select"
                  name="companyId-field"
                  id="companyId-field"
                  formControlName="companyId"
                  (change)="companySelectDropDownChange($event)"
                  [ngClass]="{ 'is-invalid': ticketFormSubmitted && formData['companyId'].errors }"
                >
                  <option selected></option>
                  @for (object of suresimCompanyIdData; track object.id) {
                    <option [ngValue]="object.id">{{object.description}}</option>    
                  }
                </select>
                <div class="invalid-feedback">A value is required</div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label for="userId-field" class="form-label text-right required">Raised By</label>
              <div class="input-group">
                <div class="input-group">
                  <select
                    class="form-select"
                    name="userId-field"
                    id="userId-field"
                    formControlName="userId"
                    [ngClass]="{ 'is-invalid': ticketFormSubmitted && formData['userId'].errors }"
                  >
                    <option selected></option>
                    @for (object of suresimUserDataPlusSelf; track object.id) {
                      <option [ngValue]="object.id">{{object.description}}</option>    
                    }
                  </select>
                  <div class="invalid-feedback">A value is required</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="mb-3">
              <label for="typeId-field" class="form-label text-right required">Type</label>
              <div class="input-group">
                <select
                  autocomplete="no-fill"
                  class="form-select"
                  name="typeId-field"
                  id="typeId-field"
                  formControlName="typeId"
                  (change)="typeDropDownChange($event)"
                  [ngClass]="{ 'is-invalid': ticketFormSubmitted && formData['typeId'].errors }"
                >
                  <option selected></option>
                  @for (object of typeIdData; track object.id) {
                    <option [ngValue]="object.id">{{object.description}}</option>    
                  }
                </select>
                <div class="invalid-feedback">A value is required</div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label for="title-field" class="form-label text-right required">Title</label>
              <input autocomplete="no-fill" type="text" id="title-field" class="form-control" placeholder="" formControlName="title" data-lpignore="true" [ngClass]="{ 'is-invalid': ticketFormSubmitted && formData['title'].errors }" />              
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="mb-3">
              <label for="affectedUserId-field" class="form-label text-right" [ngClass]="{ 'required': formData['typeId'].value == 3 }">Affected User</label>
              <div class="input-group">
                <select
                  class="form-select"
                  name="affectedUserId-field"
                  id="affectedUserId-field"
                  formControlName="affectedUserId"
                  (change)="userSelectDropDownChange($event)"
                  [ngClass]="{ 'is-invalid': ticketFormSubmitted && formData['affectedUserId'].errors }"
                >
                  <option selected></option>
                    @for (object of suresimUserData; track object.id) {
                      <option [ngValue]="object.id">{{object.description}}</option>    
                  }
                </select>
                @if(ticketFormSubmitted && formData['affectedUserId'].hasError('affectedUserRequired')) {
                  <div class="invalid-feedback">A value is required</div>
                }
              </div>              
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="deviceId-field" class="form-label text-right" [ngClass]="{ 'required': formData['typeId'].value == 3 && iccidData != undefined && iccidData.length > 0 }">ICCID</label>
              <div class="input-group">
                <select
                  class="form-select"
                  name="deviceId-field"
                  id="deviceId-field"
                  #deviceId
                  formControlName="iccid"
                  [ngClass]="{ 'is-invalid': ticketFormSubmitted && formData['iccid'].errors }"
                >
                  <option selected></option>
                  @for (object of iccidData; track object) {
                    <option [ngValue]="object">{{object}}</option>    
                  }
                </select>
              </div>              
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="details-field" class="form-label text-right required">Details</label>
              <textarea #detailsarea
                id="details-field"
                class="form-control resize-none"
                placeholder=""
                formControlName="details"
                data-lpignore="true"
                [ngClass]="{ 'is-invalid': ticketFormSubmitted && formData['details'].errors }"
                (keyup)="onDetailsChange(detailsarea.value)"
                rows="6">
              </textarea>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12" style="display: flex; justify-content: space-between;">
            <div class="input-group mb-3">
              <label class="form-check-label mb-0">High Priority&nbsp;&nbsp;&nbsp;&nbsp;</label>
            <div class="mb-0">
              <div class="form-check form-switch mb-0">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="highPriority-field"
                  formControlName="highPriority"
                  style="transform: scale(1.3);"
                  (click)="onHighPriorityCheckboxChange($event)"
                />
              </div>
            </div>
            </div>
          </div>
        </div>

        <div class="row mb-4"></div>

        <div class="row">
          <div class="col-12">
            <div class="hstack gap-2 justify-content-end">
              @if(!embeddedFormMode) {
              <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="closeForm();modal.close('Close click')">Cancel</button>
              }
              <button type="submit" class="btn btn-success" id="add-btn" [attr.disabled]="!canSubmit() ? '' : null">Create Ticket</button>
            </div>
          </div>
        </div>

      </div>
    </form>
    </div>
    <div [className]="embeddedFormMode ? 'col-3' : 'col-0'"></div>
  </div>

  <!-- <app-spinner-overlay-wrapper #spinnerOverlayWrapperComponent
    [showSpinner]="this.provisioningInProgress"
  ></app-spinner-overlay-wrapper> -->

</ng-template>

<app-completed-modal-form #completedModalForm
  (modalClosed)="completedModalHasBeenClosed()"
></app-completed-modal-form>